module.exports = __webpack_public_path__ + "static/allorganicblankets-d1fec301adf47d001ee82af09bff80f3.jpeg";